'use client';

import styled from 'styled-components';

export interface GridFormLayoutProps {
  columns?: number;
  debug?: boolean;
  breakpoint?: number;
  width?: string;
  display?: string;
  columnGap?: string;
  rowGap?: string;
  gridTemplateColumns?: string;
  outline?: string;
  gap?: string;
}

export const GridFormLayout = styled.div<GridFormLayoutProps>`
  width: ${({ width }) => width || '100%'};
  display: ${({ display }) => display || 'grid'};
  column-gap: ${({ columnGap }) => columnGap || '1rem'};
  row-gap: ${({ rowGap }) => rowGap || '1rem'};
  grid-template-columns: ${({ columns }) =>
    columns === 2 ? '1fr 1fr' : '1fr'};
  & > div {
    outline: ${({ debug }) => (debug ? '1px dashed grey' : 'none')};
  }

  @media (max-width: ${({ breakpoint }) => breakpoint || 768}px) {
    grid-template-columns: ${({ gridTemplateColumns }) =>
      gridTemplateColumns || '1fr'};
    margin-left: 1rem;
    margin-right: 1rem;
    width: calc(100% - 2rem);
  }
`;
